import { useUser } from '../contexts/UserContext';
import { resolveActiveOrganization, type ActiveOrganization } from '../utils/activeOrganization';

/** The organization (slug and display name) the current screens operate on. */
export function useActiveOrganization(): ActiveOrganization {
  const { activeTenant, isSuperadmin, tenants } = useUser();
  return resolveActiveOrganization({ activeTenant, isSuperadmin, tenants });
}
